import React from 'react';
import PropTypes from 'prop-types';

const API_URL = process.env.REACT_APP_CMS;

export default function Brochure({ brochure, shortText }) {
    return (
        <div className="brochure">
            {shortText &&
            <h3 className="brochure-short-text">
                {shortText}
            </h3>}
            <a
              href={ `${ API_URL }/assets/${ brochure.file.filename_disk }` }
              download={ brochure.file.filename_download }
              className="brochure-link"
              target="_blank"
              rel="noopener noreferrer"
            >
                { brochure.translations.text }
            </a>
        </div>
    );
}

Brochure.propTypes = {
    brochure: PropTypes.shape({
        file: PropTypes.shape(),
        type: PropTypes.string,
        translations: PropTypes.shape()
    }).isRequired,
    shortText: PropTypes.string
};

Brochure.defaultProps = {
    shortText: null
};



// WEBPACK FOOTER //
// ./src/components/content/estimation/pricing/Brochure.jsx